import user from './user'
import class_grade from './class_grade'
import exam from './exam'
import exam_grade from './exam_grade'
import counselor from './counselor'
import setting from './setting'
import final_exam from './final_exam'

export default Object.assign({},
  user,
  class_grade,
  exam,
  exam_grade,
  counselor,
  setting,
  final_exam,
)
